export function GetLanguageChoices() {return [
    { image: "unitedKingdom", name: "English", languageCode: "en" },
    { image: "czech", name: "čeština", languageCode: "cs" },
    { image: "denmark", name: "Dansk", languageCode: "da" },
    { image: "germany", name: "Deutsch", languageCode: "de" },
    { image: "spain", name: "Español ", languageCode: "es" },
    { image: "greece", name: " Ελληνικά", languageCode: 'el'},
    { image: "finland", name: "Suo̯mi", languageCode: "fi" },
    { image: "france", name: "Française", languageCode: "fr" },
    { image: "india", name: "हिन्दी", languageCode: "hi" },
    { image: "hungary", name: "Magyar", languageCode: "hu" },
    { image: "italy", name: "Italiano", languageCode: "it" },
    { image: "Latvia", name: "Latviski", languageCode: "lv" },
    { image: "netherlands", name: "Nederlands", languageCode: "nl" },
    { image: "norway", name: "Norsk", languageCode: "no" },
    { image: "poland", name: "Polski", languageCode: "pl" },
    { image: "portugal", name: "Português", languageCode: "pt" },
    { image: "russia", name: "Pусский", languageCode: "ru" },
    { image: "ukraine", name: "Yкраїнськa", languageCode: "uk" },
  

  ];}